import Vue from "vue"

import request from "@/commons/request";
import storage from '@/commons/storage';
import message from "@/components/message";

var vtk = { request, storage, message, env: process.env }

Vue.prototype.$vtk = vtk;

